<header class="wealthlane-header">
  <div class="header-container">
    <div class="logo">
      <img src="/images/logo-v2.png" alt="WealthLane Logo">
    </div>
    @if(isMobile){
    <div class="menu-container" [class.show-menu]="showMobileMenu">
      <ng-container *ngTemplateOutlet="menu"></ng-container>
    </div>
    }
    @else {
    <ng-container *ngTemplateOutlet="menu"></ng-container>
    }
    <ng-template #menu>
      <nav>
        <ul>
          <li><a>Solutions</a></li>
          <li><a>Tarifs</a></li>
          <li><a>Nous contacter</a></li>
          <li><a>Ressources</a></li>
        </ul>
      </nav>
      <div class="account">
        <button (click)="navigateToMonCompte()">Mon compte
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
    </ng-template>

    <div class="mobile-menu">
      <p-button icon="pi pi-bars" severity="secondary" (click)="showMobileMenu = !showMobileMenu" />
    </div>
  </div>
</header>